export const TITLES_SETTINGS = {
  color: true,
  fontSize: true,
  bold: true,
  italic: true,
  underline: false,
  alignment: false,
};

export const AVAILABLE_FONT_SIZES = {
  TITLE: [16, 18, 20, 22, 24, 28],
  SUBTITLE: [12, 14, 16, 18, 20],
};
